import { useEffect } from "react";
import {
  CircularProgress,
} from '@mui/material';
import styles from './IntersectionLoading.module.scss';

export const IntersectionLoading = ({
  className,
  options,
  callback,
}: {
  className?: string;
  options: Partial<IntersectionObserverInit>;
  callback: () => void;
}) => {
  useEffect(() => {
    console.log('useEffect');
    
    const _options = {
      rootMargin: '100px',
      threshold: 1.0,
      ...options,
    };

    const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
      if (entries?.[0]?.isIntersecting) {
        callback();
      }
    }, _options);
  
    const target = document.querySelector("#IntersectionLoading");
    if (target) {
      observer.observe(target)
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [callback]);

  return (
    <div className={`${styles.loadingContainer} ${className || ''}`} id="IntersectionLoading">
      <CircularProgress />
    </div>
  );
};